import React from 'react';
import PropTypes from 'prop-types';

import SVGInline from "react-svg-inline";
import { browserHistory } from "react-router";

import { InputSmall } from '../../Elements/Inputs';
import { ButtonSimple } from '../../Elements/Buttons';

import './styles.css';

// svgs
import checkmarkSVG from "../../inlineSVGs/checkmarkSVG";
import {clientMedia} from "../../../Config/Settings";

const SendResetMail = ({ onChangeMail, onSubmit, isSubmitted }) => {


    // Please enter your E-mail address<br/>
    // and we'll send you a link to reset your password
    //
    const renderForm = () => (
        <div className="content-wrapper rtl">
            <div className="text">
                <p>
                    מה המייל שלך? מיד נשלח לך לינק לחידוש סיסמה
                </p>
            </div>
            <InputSmall
                onChange={(event) => onChangeMail(event.target.value)}
                placeholder="הכנס את המייל שלך"
                type="email"
            />
            <ButtonSimple onPress={() => onSubmit()} label="שלח לינק" />
        </div>
    );

    // An email with a link to rest your password was send successfully!
    const renderSubmitted = () => {
        return (
            <div className={'content-wrapper rtl submitted'}>
                <SVGInline svg={checkmarkSVG} className={`checkmark-icon`} component="i"/>
                <p className={'submitted-text'}>
                    מייל עם הלינק לחידוש הסיסמא נשלח בהצלחה!
                </p>

                <ButtonSimple
                    onPress={ () => browserHistory.replace('/') }
                    label={'חזרה'}
                    customClass={'btn-back-reset-password'}
                />
            </div>
        )
    };

    return (
        <div className="reset-mail-wrapper">
            <div className="flying-wrapper">
                <img src={`${clientMedia()}/img/logos/flying-up-mugics.png`} alt="flying-logo"/>
            </div>
            {isSubmitted ? renderSubmitted() : renderForm()}
        </div>
    )
};

SendResetMail.propTypes = {
    onChangeMail: PropTypes.func,
    onSubmit: PropTypes.func,
    isSubmitted: PropTypes.bool,
};

export default SendResetMail;



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/SendResetMail/SendResetMail.js